export enum ApiTab {
  WebVisits = 'web-visits',
  OfflineSales = 'offline-sales',
  FootTraffic = 'foot-traffic',
}
